export default "__VITE_ASSET__DEbkVXjs__"